"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const antd_1 = require("antd");
const HeaderMenuComponent_1 = __importDefault(require("../../../components/headerMenuComponent/HeaderMenuComponent"));
const home_webp_1 = __importDefault(require("../../../assets/images/HeaderCarrousel/home.webp"));
const home1_webp_1 = __importDefault(require("../../../assets/images/HeaderCarrousel/home1.webp"));
const home2_webp_1 = __importDefault(require("../../../assets/images/HeaderCarrousel/home2.webp"));
const home3_webp_1 = __importDefault(require("../../../assets/images/HeaderCarrousel/home3.webp"));
const home4_webp_1 = __importDefault(require("../../../assets/images/HeaderCarrousel/home4.webp"));
const home5_webp_1 = __importDefault(require("../../../assets/images/HeaderCarrousel/home5.webp"));
const home6_webp_1 = __importDefault(require("../../../assets/images/HeaderCarrousel/home6.webp"));
const home7_webp_1 = __importDefault(require("../../../assets/images/HeaderCarrousel/home7.webp"));
const home8_webp_1 = __importDefault(require("../../../assets/images/HeaderCarrousel/home8.webp"));
const home9_webp_1 = __importDefault(require("../../../assets/images/HeaderCarrousel/home9.webp"));
require("./HomeHeader.scss");
const helpers_1 = require("../../../utils/helpers");
const detectDevice_1 = __importDefault(require("../../../utils/detectDevice"));
const HomeHeader = () => {
    const ref = (0, react_1.useRef)({});
    const [randomImages, setRandomImages] = (0, react_1.useState)([]);
    const [activeImage, setActiveImage] = (0, react_1.useState)(0);
    const { isMobile } = (0, detectDevice_1.default)(992);
    const randomizeImages = (0, react_1.useCallback)(arrayImages => {
        const shuffle = (array) => {
            const tempArray = [...array];
            tempArray.forEach((_, index) => {
                const randomIndex = Math.floor(Math.random() * (index + 1));
                [tempArray[index], tempArray[randomIndex]] = [tempArray[randomIndex], tempArray[index]];
            });
            return tempArray;
        };
        const tmpRandomImages = shuffle(arrayImages);
        return tmpRandomImages;
    }, []);
    const cacheImages = (0, react_1.useCallback)(() => {
        const images = (0, helpers_1.decryptStorage)('XP360:HOME_IMAGES');
        setRandomImages(images || [home_webp_1.default, home1_webp_1.default, home2_webp_1.default, home3_webp_1.default, home4_webp_1.default, home5_webp_1.default, home6_webp_1.default, home7_webp_1.default, home8_webp_1.default, home9_webp_1.default]);
    }, []);
    (0, react_1.useEffect)(() => {
        cacheImages();
    }, [randomizeImages, cacheImages]);
    (0, react_1.useEffect)(() => {
        (0, helpers_1.encryptStorage)('XP360:HOME_IMAGES', randomizeImages([home_webp_1.default, home1_webp_1.default, home2_webp_1.default, home3_webp_1.default, home4_webp_1.default, home5_webp_1.default, home6_webp_1.default, home7_webp_1.default, home8_webp_1.default, home9_webp_1.default]));
    }, []);
    const handleGoTo = (0, react_1.useCallback)(num => {
        ref.current.goTo(num);
    }, [ref]);
    return (react_1.default.createElement("div", { className: "HomeHeader" },
        react_1.default.createElement(HeaderMenuComponent_1.default, null),
        react_1.default.createElement("section", { className: "header-phrase-container noselect" },
            react_1.default.createElement("div", { className: "header-phrase" },
                react_1.default.createElement("div", null,
                    react_1.default.createElement("strong", null, "Aluguel por temporada "),
                    react_1.default.createElement("br", null),
                    react_1.default.createElement("span", null, "sem burocracias")),
                react_1.default.createElement("div", null,
                    react_1.default.createElement("span", { className: "sub-title" }, "Apartamentos mobiliados pelo "),
                    react_1.default.createElement("span", { className: "bold sub-title" }, "tempo que desejar."),
                    react_1.default.createElement("br", null),
                    react_1.default.createElement("span", { className: "sub-title" }, "Alugar com "),
                    react_1.default.createElement("span", { className: "bold sub-title" }, "conforto, privacidade e praticidade "),
                    react_1.default.createElement("span", { className: "sub-title" }, "nunca foi t\u00E3o f\u00E1cil.")))),
        react_1.default.createElement("section", { className: "header-background" },
            react_1.default.createElement(antd_1.Carousel, { ref: ref, autoplay: true, dotPosition: "bottom", className: "home-carousel", effect: isMobile ? 'scrollx' : 'fade', autoplaySpeed: 7000, focusOnSelect: true, beforeChange: (_, b) => setActiveImage(b), draggable: isMobile, swipeToSlide: isMobile }, randomImages.map(image => (react_1.default.createElement("div", { className: "home-carousel-item noselect" },
                react_1.default.createElement("img", { loading: "lazy", src: image, alt: "" })))))),
        react_1.default.createElement("div", { className: "dot-container" },
            react_1.default.createElement("div", null, randomImages.map((_, idx) => (react_1.default.createElement("button", { type: "button", className: `dot-icon ${activeImage === idx ? 'active-dot' : ''}`, onClick: () => handleGoTo(idx) },
                react_1.default.createElement("span", null)))))),
        react_1.default.createElement("div", { className: "header-logo-container" })));
};
exports.default = HomeHeader;
